import { cn } from '@/lib/utils';
import { BadgeCheck } from 'lucide-react';
import React from 'react';

interface CreveLogoProps {
  className?: string;
  /** Force the wordmark text to show even below the sm breakpoint */
  alwaysShowWordmark?: boolean;
}

/**
 * Creve wordmark — a stylized "C" with an integrated checkmark (represented
 * here with a coral BadgeCheck mark) paired with the "Creve" wordmark in
 * bold Sora. The wordmark text hides below the sm breakpoint; the mark
 * always shows.
 */
export const CreveLogo: React.FC<CreveLogoProps> = ({
  className,
  alwaysShowWordmark = false,
}) => {
  return (
    <div className={cn('flex items-center gap-2', className)}>
      <span className='flex h-8 w-8 items-center justify-center rounded-full bg-secondary'>
        <BadgeCheck className='h-5 w-5 text-primary' strokeWidth={2.5} />
      </span>
      <span
        className={cn(
          'font-heading text-xl font-bold tracking-tight text-foreground',
          alwaysShowWordmark ? '' : 'hidden sm:inline'
        )}
      >
        Creve
      </span>
    </div>
  );
};

export default CreveLogo;
